export function lastFour (ssn: string): string {

    const ssnTrimmed = ssn.trim();
    const ssnLength = ssnTrimmed ? ssnTrimmed.length : 0;

    if (ssnLength === 9) {
      return `***-**-${ssnTrimmed.substring(5, ssnLength)}`;
    }

    return `***-**-${ssnTrimmed.substring(7, ssnLength)}`;
}

export function withDashes (ssn: string): string {
  if (isInvalid(ssn)) {
    return "";
  }

  const ssnTrimmed = ssn.trim();
  const ssnLength = ssnTrimmed ? ssnTrimmed.length : 0;

  if (ssnLength === 9) {
    return `${ssnTrimmed.slice(0, 3)}-${ssnTrimmed.slice(3, 5)}-${ssnTrimmed.slice(5, 9)}`;
  }

  return ssnTrimmed;
}

export function withoutDashes (ssn: string): string {
  if (isInvalid(ssn)) {
    return "";
  }

  const ssnTrimmed = ssn.trim();
  const ssnLength = ssnTrimmed ? ssnTrimmed.length : 0;

  if (ssnLength === 11) {
    return ssnTrimmed.replaceAll("-", "");
  }

  return ssnTrimmed;
}

export function isInvalid (ssn: string) {
  return ssn === undefined || ssn === null || !(ssn.length === 9 || ssn.length === 11);
}